import { DEV_EXPERIMENT_SUFFIX } from '../../../analytics/app/common/constants/growthbook';

function getExperimentName(name: string) {
  const { ENVIRONMENT } = useRuntimeConfig().public;

  return ENVIRONMENT === 'production' ? name : `${name}${DEV_EXPERIMENT_SUFFIX}`;
}

export const EXPERIMENTS = {
  get CHECKOUT_WHITENING() {
    return getExperimentName('checkout_whitening');
  },
  get UPSELL_111() {
    return getExperimentName('upsell_111');
  },
  get SUPPLEMENTS() {
    return getExperimentName('supp');
  },
  get WW_PRICING_C() {
    return getExperimentName('WW_pricing_C');
  },
  get LATAM_PRICING_C() {
    return getExperimentName('LatAm_pricing_C');
  },
  get UPSELL_WW() {
    return getExperimentName('upsell_WW');
  },
  get UPSELL_LAT_AM() {
    return getExperimentName('upsell_latam');
  },
  get PRELAND_30MONEYBACK() {
    return getExperimentName('preland_30moneyback');
  },
  get THANKYOU_TIPS() {
    return getExperimentName('thankyou_tips');
  },
  get TEST_FINISHED_EXPERIMENT() {
    return getExperimentName('test_finished_experiment');
  },
  get US_PRICING_TEST_2() {
    return getExperimentName('US_pricingtest_2');
  },
} as const;

export type CheckoutFormVariant = 'control' | 'a' | 'b' | 'c' | 'd' | 'e';
